import React, { createContext, useContext } from 'react';
import { useSearchHelper } from '../logic/searchHelper';
import moment from 'moment';
import useDerivative from '../hooks/useDerivative';
import PropTypes from 'prop-types';

const SearchContext = createContext({
  searchOptions: null,
  updateSearchOptions: () => {},
});

export const SearchProvider = ({ children }) => {
  const currentDerivative = useDerivative();
  const defaultSearchOptions = {
    dep: '',
    dest: '',
    depg: '',
    destg: '',
    days: '12345',
    depdate: moment().format('DD.MM.YYYY'),
    deptime: '08:00',
    radius: '10',
    type: currentDerivative.type === 'event' ? 'single' : 'regular',
    depEvent: '',
    destEvent: '',
  };
  const { searchOptionsState, updateSO } =
    useSearchHelper(defaultSearchOptions);
  return (
    <SearchContext.Provider
      value={{
        searchOptions: searchOptionsState,
        updateSearchOptions: updateSO,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSearchOptions = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearchOptions must be used within a SearchProvider');
  }
  return context;
};
